import { AppNS } from 'app';

export const prepareAvailableDates = (data: AppNS.Params): AppNS.Params => {
  const output: AppNS.Params = {};
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      output[key] = data[key];
    }
  });
  return output;
};
